module.exports = __webpack_public_path__ + "static/media/momentum-small.f89a93cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/momentum-small.jpg
// module id = 2812
// module chunks = 0